export default "skymp5-front/2b50e31a9593206189667c54e7cb86d5.png";